import { render } from "./B2bFiltersPendingTask.vue?vue&type=template&id=5d0fd910&scoped=true&lang=pug"
import script from "./B2bFiltersPendingTask.vue?vue&type=script&lang=js"
export * from "./B2bFiltersPendingTask.vue?vue&type=script&lang=js"

import "./B2bFiltersPendingTask.vue?vue&type=style&index=0&id=5d0fd910&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0fd910"]])

export default __exports__